(function () {
  'use strict';

  var ONLY_FLAGGED = false;

  var SWATCH_SELECTOR = [
    '[data-grid-swatch-form] .swatch__button',
    '[data-grid-swatch-form] [data-tooltip]',
    '[data-grid-swatch-form] label',
    '[data-grid-swatch-form] input[type="radio"]'
  ].join(', ');

  var style = document.createElement('style');
  style.textContent =
    '.product-item__bg__inner.vsh-visible{' +
      'opacity:1 !important;visibility:visible !important;z-index:3;' +
    '}' +
    '.product-item.vsh-active .product-item__bg__under{' +
      'opacity:0 !important;visibility:hidden !important;' +
    '}';
  document.head.appendChild(style);

  function getSwatchValue(swatch) {
    var v = swatch.getAttribute('data-tooltip') ||
            swatch.getAttribute('data-swatch-value') ||
            swatch.getAttribute('data-value');
    if (!v) {
      var input = swatch.matches('input') ? swatch : swatch.querySelector('input');
      if (input) v = input.value;
    }
    if (!v) v = (swatch.textContent || '');
    return (v || '').trim().toLowerCase();
  }

  function findVariantImage(card, value) {
    if (!value) return null;
    var inners = card.querySelectorAll('.product-item__bg__inner[data-variant-title]');
    var i, j, title, parts;

    for (i = 0; i < inners.length; i++) {
      title = (inners[i].getAttribute('data-variant-title') || '').toLowerCase();
      parts = title.split('/');
      for (j = 0; j < parts.length; j++) {
        if (parts[j].trim() === value) return inners[i];
      }
    }
    for (i = 0; i < inners.length; i++) {
      title = (inners[i].getAttribute('data-variant-title') || '').toLowerCase();
      if (title.indexOf(value) !== -1) return inners[i];
    }
    return null;
  }

  function clearCard(card) {
    card.classList.remove('vsh-active');
    var shown = card.querySelectorAll('.product-item__bg__inner.vsh-visible');
    for (var i = 0; i < shown.length; i++) shown[i].classList.remove('vsh-visible');
  }

  function isAllowed(card) {
    if (!ONLY_FLAGGED) return true;
    return !!card.querySelector('grid-swatch[data-variant-img="true"]');
  }

  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest) return;
    var swatch = e.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    var card = swatch.closest('.product-item');
    if (!card || !isAllowed(card)) return;

    var inner = findVariantImage(card, getSwatchValue(swatch));
    clearCard(card);
    if (inner) {
      card.classList.add('vsh-active');
      inner.classList.add('vsh-visible');
    }
  });

  document.addEventListener('mouseout', function (e) {
    if (!e.target.closest) return;
    var swatch = e.target.closest(SWATCH_SELECTOR);
    if (!swatch) return;

    var card = swatch.closest('.product-item');
    if (!card) return;

    var to = e.relatedTarget;
    if (to && to.closest && to.closest(SWATCH_SELECTOR) && card.contains(to)) return;
    if (to && swatch.contains(to)) return;

    clearCard(card);
  });
})();
